import React from "react";
export default class Footer extends React.Component {
  constructor() {
    super();
    this.state = {};
  }
  render() {
    return (
      <footer className="gbcr-main-grid-child">
        <p>CX Cargo Release (UKD)</p>
      </footer>
    );
  }
}
